import axios from 'axios';
import { JournalistBatchModel } from '../Models/JournalistBatchModel';

const getJournalistBatch = (batch: JournalistBatchModel) => axios.post(`classifications/${batch.classificationsId[0]}/journalists`, batch);
const insertJournalistBatch = (batch: JournalistBatchModel) => axios.post(`classifications/${batch.classificationsId[0]}/journalists/insert-batch`, batch);
const deleteJournalistBatch = (batch: JournalistBatchModel) => axios.patch(`classifications/${batch.classificationsId[0]}/journalists/delete-batch`, batch);

export default {
    getJournalistBatch,
    insertJournalistBatch,
    deleteJournalistBatch
};